import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { UpdateTemplateDocxMutation, UpdateTemplateDocxMutationVariables } from '@/graphql/generated/graphql';
import { UpdateTemplateDocxDocument } from '@/graphql/generated/graphql';
export type TemplateDocxUpdateInput = {
  ItemId: string
  OrganizationIds?: string[]
  TemplateId?: string
  OriginalUrl?: string
  OriginalKey?: string
  OriginalName?: string
  SizeBytes?: number
  TokenizedUrl?: string
  TokenizedKey?: string
  TokenVersion?: number
  Status?: string
}

export type UpdateTemplateDocxResponse = {
  data: {
    updateTemplateDocx: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useUpdateTemplateDocx = () => {
  const mutation = useMutation({
    mutationKey: ['update-template-docx'],
    mutationFn: (variables: TemplateDocxUpdateInput) => {
      return graphqlClient.request<UpdateTemplateDocxMutation>(UpdateTemplateDocxDocument,
        variables
      )
    }
  })

  return {
    ...mutation,
    updateTemplateDocx: mutation.mutate,
    updateTemplateDocxAsync: mutation.mutateAsync,
  }
}

export const UPDATE_TEMPLATE_DOCX_MUTATION = UpdateTemplateDocxDocument;
